import { render } from "./TitledContainer.vue?vue&type=template&id=3f4b9a74"
import script from "./TitledContainer.vue?vue&type=script&lang=js"
export * from "./TitledContainer.vue?vue&type=script&lang=js"

import "./TitledContainer.vue?vue&type=style&index=0&id=3f4b9a74&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__